// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XDmQ","content":"styles_content__qqrpu"};